// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FsKv","questions":"styles_questions__1uRdo","footer":"styles_footer__3tyFC"};